import { render, staticRenderFns } from "./TextModalComponent.vue?vue&type=template&id=052b095e"
import script from "./TextModalComponent.vue?vue&type=script&lang=ts"
export * from "./TextModalComponent.vue?vue&type=script&lang=ts"
import style0 from "./TextModalComponent.vue?vue&type=style&index=0&id=052b095e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports